module.exports = __webpack_public_path__ + "components/flag/static/square/by-9b3f33a1e4b930c1cebc596edc0a22aa.svg";